export default "__VITE_ASSET__899952e1__"